module.exports = __webpack_public_path__ + "img/14_5.fa848f30.png";